module.exports = __webpack_public_path__ + "static/media/TSNPDCL.999cf8b8.jpg";